import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { CardContent, CardHeader, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import getChartData from "utils/getChartData";

const TariffWiseConsumersBarChart = ({ tariffType, tariffRecords }) => {
  const initialOption = {
    chart: {
      type: "bar",
      stacked: true,
    },
    colors: [tariffType.color],
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    stroke: {
      width: 1,
      colors: ["#fff"],
    },

    xaxis: {
      categories: [],
      labels: {
        formatter: function (val) {
          return val;
        },
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    yaxis: {
      title: {
        text: undefined,
      },
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    fill: {
      opacity: 1,
      type: "gradient",
    },
    legend: {
      position: "bottom",
      horizontalAlign: "left",
    },
  };

  const [data, setData] = useState({});
  const [options, setOptions] = useState(initialOption);
  const series = useMemo(
    () => [
      {
        name: tariffType.title,
        data: data?.[tariffType.title] || [],
      },
    ],
    [data]
  );

  useEffect(() => {
    if (tariffRecords) {
      const { barChartData, barChartLabels } = getChartData(
        tariffRecords,
        "tariffDetails",
        "tariffName",
        "count",
        "month"
      );
      setData(barChartData);
      setOptions((prev) => ({
        ...prev,
        xaxis: { ...prev.xaxis, categories: barChartLabels },
        colors: [tariffType.color],
      }));
    }
  }, [tariffRecords, tariffType?.title]);

  return (
    <>
      <CardHeader
        title={
          <Typography variant="subtitle1" fontWeight={700}>
            {tariffType.title}
          </Typography>
        }
      />
      <CardContent>
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={450}
        />
      </CardContent>
    </>
  );
};

TariffWiseConsumersBarChart.propTypes = {
  tariffType: PropTypes.object,
  tariffRecords: PropTypes.array,
};

export default TariffWiseConsumersBarChart;
